'use client';
import AccordionGroup from 'components/AccordionGroup';
import Button from 'components/buttons/Button';
import { useState } from 'react';

import { FormattedAccordion } from './Accordion';

interface FilterStackProps {
  accordions: FormattedAccordion[];
}

const FilterStack = ({ accordions }: FilterStackProps) => {
  const categories = [
    ...new Set(accordions.map((accordion) => accordion.categoryTag)),
  ];

  const [selectedCategory, setSelectedCategory] = useState<string>(
    categories[0]
  );

  const filteredAccordions = accordions.filter(
    (accordion) => accordion.categoryTag === selectedCategory
  );

  return (
    <div className="filter-accordion-stack">
      <div className="nav-filters">
        {categories.map((category) => (
          <Button
            className={`${selectedCategory === category ? 'selected' : ''}`}
            key={category}
            onClick={() => setSelectedCategory(category)}
            size="quarter-width"
            title={category}
            variant="outlined"
          />
        ))}
      </div>
      <div className="accordion-group">
        <AccordionGroup accordions={filteredAccordions} />
      </div>
    </div>
  );
};

export default FilterStack;
